








































































































































import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";
import VJsonschemaForm from "@pan-gms/vuetify-jsonschema-form";
import { ApplicationBudget, Feedback } from "@/entities";
import { AppConstants as _app } from "@/shared/app.constants";
import "vuetify/dist/vuetify.min.css";
import "@/styles/iucn/financial.css";
import "@/styles/iucn/table-budget.css";
import "@/styles/iucn/budget.css";
import "@pan-gms/vuetify-jsonschema-form/dist/main.css";
import ImportButton from "@/components/common/Buttons/ImportButtons.vue";
import NavigationButtons from "@/components/App/Modules/GMS/Workspace/Components/NavigationButtons.vue";
import { Locales } from "@/i18n/locales";

const namespace: string = "migration";

@Component({
  components: {
    VJsonschemaForm,
    ImportButton,
    NavigationButtons,
  },
})
export default class series extends Vue {
  @Getter("currency", { namespace: "migration" }) currency: string;
  @Getter("_appUser", { namespace: "RootApp" }) _username!: string;
  @Getter("_appUserId", { namespace: "RootApp" }) _userid!: number;
  @Action("importBudgetFile", { namespace: "application" }) importFile: any;
  @State("feedback") feedback!: Feedback;
  @Prop() appData!: any;
  @Prop() readOnly: boolean;
  @Prop() appId!: number;
  @Prop() budgetLimit: number;
  @Prop() grantType: any;
  @Prop() isDirty!: boolean;
  @Prop() budgetInstruction!: any;
  @Prop() indirectCost!: any;
  @Prop() budgetFootnote!: string;
  @Prop() schema: any;
  @Prop() rootSchema: any;
  @Prop() isFixedindirectCost!: any;
  /** declare variables */
  formValid: boolean = false;
  schemaformKey: number = 0;
  data: any = {};
  isSelecting: boolean = false;
  budgetValidations: any = [];
  menuButtons = _app.budgetMenuButtons;
  defaultLocale: string = localStorage.getItem("language") || Locales.EN;

  mounted() {}

  get options(): any {
    return {
      disableAll: this.readOnly && this.readOnly === true ? true : false,
      currency: this.currency,
      transactionId: this.appId,
      //@ts-ignore
      rights: this.$can("manage", "feedback")
        ? _app.actions.manage
        : _app.actions.read,
      user: this._userid,
      entity: _app.entities.application,
      feedbacks: this.feedback.feedbackHeaders,
      PopulateExcel: this.$services.budget.exportToExcel,
      downloadAction: this.$services.budget.generateTemplate,
      indirectCost: this.indirectCost,
      formatString: this.$services.format.personalizeString,
      actions: {},
      fileSizeLimit: this.appSettings.MaxFileSizeLimit,
      isFixedindirectCost: this.isFixedindirectCost,
      locale: this.defaultLocale
    };
  }

  /** get schema properties to populate the left panel*/
  get subSchema(): any {
    return this.schema;
  }

  onButtonClick() {
    this.isSelecting = true;
    window.addEventListener(
      "focus",
      () => {
        this.isSelecting = false;
      },
      { once: true }
    );

    //@ts-ignore
    this.$refs.uploader.click();
  }

  onAddFiles(e: any) {
    let files = e.target.files[0];
    let maxSize = this.appSettings.MaxFileSizeLimit || 10485760;
    if (files) {
      const { name, type, size } = files;
      // TODO: Show snakbar status
      if (size < maxSize) {
        this.importFile({
          file: files,
          transactionId: parseInt(this.$route.params.id),
          schema: this.subSchema,
          context: "migration"
        }).then((resp) => {
          if (resp.Result === "OK") {
            this.appData.applicationBudget = resp.Record;
            this.budgetValidations = resp.Validation;
            this.$emit("totalChanged", resp.Record.summary);
            this.$emit("input", true);
            this.schemaformKey += 1;
          }
        });
      }
    }
  }

  exportBudget(e: any) {
    this.$services.budget.exportToExcel(this.appId, this.appData.projectTitle, "migration");
  }

  downloadBudget(e: any) {
    this.$services.budget.generateTemplate(this.appId, this.appData.projectTitle);
  }

  get footNotes() {
    let notes = [],
      tmp,
      arr = [];
    if (
      this.subSchema.hasOwnProperty("budgetType") &&
      this.subSchema["budgetType"] === "TSG"
    ) {
      _app.budgetFootnoteKeys.forEach((item) => {
        if (item === "coFinDesc") {
          tmp = this.$services.format.formatCurrency(
            0.8 * this.budgetLimit,
            this.currency,
            this.defaultLocale
          );
          arr.push(tmp);
          tmp = this.$services.format.formatCurrency(
            0.9 * this.budgetLimit,
            this.currency,
            this.defaultLocale
          );
          arr.push(tmp);
          tmp = this.$services.format.personalizeString(
            `${this.$t(item)}`,
            arr
          );
        }
        notes.push(tmp);
      });
    }
    return notes;
  }

  /** error event */
  showError(err) {
    window.alert(err);
  }

  /** change event */
  showChange(e) {
    this.$emit("input", true);
  }

  /** input event */
  showInput(e) {
    this.$emit("input", true);
  }

  /** save the comment */
  saveComment(comment: any, obj: any) {
    comment.user = this._username;
    this.$services.comment.Save(comment, obj).then((resp: any) => {
      if (resp.Result == "OK") {
        resp.Record["comment"] = resp.Record["Comment"];
        obj.comments.unshift(resp.Record);
      }
    });
  }

  /** resolve the comment */
  resolveComment(obj: any) {
    this.$services.comment.Resolve(obj);
  }

  @Watch("model")
  onDataChanged(value: any, oldValue: any) {
    this.schemaformKey += 1;
  }

  downloadTemplate() {
    this.$services.budget.generateTemplate(parseInt(this.$route.params.id), this.appData.projectTitle, "migration")
  }
}
